import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { publish } from '@wh/message-bus';
import { StateType as SessionStateType } from '@central-products/interface-session-service';
import { triggerCommand } from './messageBusHelpers';

import { COMMAND_SESSION_SERVICE_STATE_GET, EVENT_SESSION_SERVICE_STATE_GET, commandMyAccountStart, commandMyAccountCancel } from './events';

var type = '@myaccount/myaccount-button';

var MyAccountButtonWrapper = function (_Component) {
  _inherits(MyAccountButtonWrapper, _Component);

  function MyAccountButtonWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MyAccountButtonWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyAccountButtonWrapper.__proto__ || _Object$getPrototypeOf(MyAccountButtonWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.handelSessionStateGet = function (env) {
      if (SessionStateType.SESSION_EXISTS === env.data.state) {
        publish(commandMyAccountStart);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MyAccountButtonWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      triggerCommand({ topic: COMMAND_SESSION_SERVICE_STATE_GET, data: {} }, { topic: EVENT_SESSION_SERVICE_STATE_GET, callback: this.handelSessionStateGet });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      publish(commandMyAccountCancel);
    }

    //flow has  SessionServiceStateEnvelopType so i have to put any

  }, {
    key: 'render',
    value: function render() {
      return React.createElement('div', { key: 'cp-myacc-button', id: 'cp-ma-wrapper' });
    }
  }]);

  return MyAccountButtonWrapper;
}(Component);

export default {
  type: type,
  render: function render() {
    return React.createElement(MyAccountButtonWrapper, null);
  }
};